export const payslipreportDetails = [
  {
    key:"1",
    Image: "user-32.jpg",
    Name: "Anthony Lewis",
    Role: "Finance",
    PaidAmount: "$3000",
    PaidMonth: "$3000",
    PaidYear: "$3000",
  },
  {
    key:"2",
    Image: "user-09.jpg",
    Name: "Brian Villalobos",
    Role: "Developer",
    PaidAmount: "$2500",
    PaidMonth: "$2500",
    PaidYear: "$2500",
  },
  {
    key:"3",
    Image: "user-37.jpg",
    Name: "Connie Waters",
    Role: "Developer",
    PaidAmount: "$2800",
    PaidMonth: "$2800",
    PaidYear: "$2800",
  },
  {
    key:"4",
    Image: "user-33.jpg",
    Name: "Doglas Martini",
    Role: "Manager",
    PaidAmount: "$3300",
    PaidMonth: "$3300",
    PaidYear: "$3300",
  },
  {
    key:"5",
    Image: "user-35.jpg",
    Name: "Elliot Murray",
    Role: "Finance",
    PaidAmount: "$3600",
    PaidMonth: "$3600",
    PaidYear: "$3600",
  },
  {
    key:"6",
    Image: "user-01.jpg",
    Name: "Harvey Smith",
    Role: "Developer",
    PaidAmount: "$2000",
    PaidMonth: "$2000",
    PaidYear: "$2000",
  },
  {
    key:"7",
    Image: "user-02.jpg",
    Name: "Linda Ray",
    Role: "Finance",
    PaidAmount: "$3400",
    PaidMonth: "$3400",
    PaidYear: "$3400",
  },
  {
    key:"8",
    Image: "user-38.jpg",
    Name: "Lori Broaddus",
    Role: "Developer",
    PaidAmount: "$4000",
    PaidMonth: "$4000",
    PaidYear: "$4000",
  },
  {
    key:"9",
    Image: "user-36.jpg",
    Name: "Rebecca Smtih",
    Role: "Executive",
    PaidAmount: "$4500",
    PaidMonth: "$4500",
    PaidYear: "$4500",
  },
];
